import React from "react";

const Hero = () => (
	<section className="bg-yellow-300 text-white py-20 text-center">
		<div className="max-w-4xl mx-auto px-4">
			<h2 className="text-5xl font-extrabold mb-4">
				Empowering Your Digital Journey
			</h2>
			<p className="text-xl text-white/90 mb-6">
				Lieuriche International Limited provides innovative IT solutions
				tailored for growth and success.
			</p>
			<a
				href="#contact"
				className="bg-white text-yellow-500 px-6 py-3 rounded shadow hover:bg-gray-100 font-bold"
			>
				Contact Us
			</a>
		</div>
	</section>
);

export default Hero;
